module.exports = "pegasus_template/assets/lp/charity/logo.png";